import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'

export interface TypeHeaderDropdownMenuFields {
  internalName?: EntryFieldTypes.Symbol
  title: EntryFieldTypes.Symbol
  links?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton>>
}

export type TypeHeaderDropdownMenuSkeleton = EntrySkeletonType<TypeHeaderDropdownMenuFields, 'headerDropdownMenu'>
export type TypeHeaderDropdownMenu<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHeaderDropdownMenuSkeleton,
  Modifiers,
  Locales
>

export function isTypeHeaderDropdownMenu<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHeaderDropdownMenu<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'headerDropdownMenu'
}
